/**
 * useBestTime — historical (day-of-week, hour) posting performance.
 * Reads marketing.meta_best_time_v. Used to render a 7x24 heatmap and
 * suggest the top-3 slots.
 */
import { useQuery } from '@tanstack/react-query';
import { marketing } from '@/lib/supabase/marketing';

export interface BestTimeCell {
  dow: number;              // 0=Sun … 6=Sat, IST
  hour_ist: number;         // 0..23
  posts: number;
  avg_interactions: number;
  avg_reach: number;
  avg_engagement_pct: number | null;
}

export function useBestTime() {
  return useQuery<BestTimeCell[]>({
    queryKey: ['best-time'],
    queryFn: async () => {
      const { data, error } = await marketing.from('meta_best_time_v').select('*');
      if (error) throw error;
      return (data ?? []) as BestTimeCell[];
    },
    staleTime: 5 * 60_000,
  });
}
